import { colors } from '@globals/themes/defaultTheme'
import { semiBoldFontWeight, spacing, tabletQuery } from '@globals/themes/themeConstants'
import ArrowBackIcon from '@mui/icons-material/ArrowBackIos'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import { SxProps, styled } from '@mui/material/styles'
import { DRAWER_WIDTH } from './Nav.constants'

export const StyledListItem = styled(ListItem)({
  fontWeight: semiBoldFontWeight,
  padding: 0,
  marginBottom: 2,
  '& .MuiListItemButton-root': {
    paddingLeft: 24,
    paddingTop: 3,
    paddingBottom: 3,
    borderRadius: 5,
    boxSizing: 'border-box',
    border: '1px solid transparent', // 'transparent' required to stop shifts on focus
  },
  '& .MuiListItemButton-root:hover': {
    backgroundColor: colors.blueExtraLight,
  },
  '& .MuiListItemButton-root:focus': {
    backgroundColor: `${colors.white} !important`,
    border: `1px solid ${colors.bluePrimary}`,
    '& *': {
      color: `${colors.blueDark} !important`,
    },
  },
  '& .Mui-focusVisible': {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.bluePrimary,
    backgroundColor: 'transparent !important',
  },
  '& .Mui-selected': {
    backgroundColor: `${colors.blueUltraLight} !important`,
    '& *': {
      color: `${colors.bluePrimary} !important`,
    },
  },
  '& .Mui-selected.Mui-focusVisible': {
    backgroundColor: `${colors.blueUltraLight} !important`,
    opacity: 1,
  },
  '& .Mui-disabled': {
    opacity: 1,
    backgroundColor: colors.grayUltraLight,
    '& svg': {
      color: colors.grayPrimary,
    },
    '& span': {
      color: colors.grayMedium,
    },
  },
  '& .MuiTypography-root': { fontWeight: semiBoldFontWeight },
  '& .MuiListItemIcon-root': { minWidth: 32 },
})

export const StyledArrowBackIcon = styled(ArrowBackIcon)({
  paddingLeft: 8,
  stroke: 'currentcolor',
  strokeWidth: 1,
})

export const NavContainer = styled('div')({
  padding: 0,
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 8,
})

export const StyledDrawer = styled(Drawer)(() => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: DRAWER_WIDTH,
    boxSizing: 'border-box',
    borderRadius: 0,
    boxShadow: 'none',
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    paddingBottom: spacing(3),
    height: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}))

export const IconButtonStyled = styled(IconButton)({
  height: 40,
  '&.MuiAppBar-root': {
    backgroundColor: colors.bluePrimary,
  },
})

export const appBarTypographyStyle: SxProps = {
  [tabletQuery]: {
    mt: 1,
  },
}
